import { render, staticRenderFns } from "./Laryer.vue?vue&type=template&id=0c13f35f"
import script from "./Laryer.vue?vue&type=script&lang=js"
export * from "./Laryer.vue?vue&type=script&lang=js"
import style0 from "./Laryer.vue?vue&type=style&index=0&id=0c13f35f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports